<template>
    <div class="new-contract">
        <modal class="house-list" :display="modalStatus.houseList" @modalStatus="closeModal()" >
            <h1>
                選擇房源
            </h1>
            <div class="group">
                <table-search v-model="filter.word" :setDefault="isDefault"></table-search>
            </div>
            <div class="content">
                <div class="table-title">
                    <span class="name">房源名稱</span>
                    <span class="address">房源地址</span>
                    <span class="agent">房東</span>
                    <span class="rent">租金</span>
                </div>
                <div class="table-body">
                    <ul :key="'height'+componentKey" v-bind:style="{'height': modalHeight}">
                        <li v-for="(item, index) in filterByWord" :key="index">
                            <default-radio v-model="selectedHouseInfo.houseCid" :isPropChecked="false" :val="item.houseCid"></default-radio>
                            <span class="name">{{item.houseName}}</span>
                            <span class="address">{{item.address}}</span>
                            <span class="agent">{{item.agentName}}</span>
                            <span class="rent">{{toCurrency(item.rent)}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button" @click="setHouseInfo(), closeModal()">確認</button>
            </div>
        </modal>
        <alart-msg :display="alart.success" styleType="success" @alartStatus="alart.success = false, changeNotifyStatus()">
            <span class="title" slot="title">{{msg.success}}</span>
        </alart-msg>
        <alart-msg :display="alart.fail" styleType="error" @alartStatus="alart.fail = false, changeUploadStatus()">
            <span class="title" slot="title">{{msg.error}}</span>
        </alart-msg>
        <div class="contract-state">
            <div class="contract-state-wrap">
                <span class="progress">
                    <span class="progress-bar">
                        <span class="progress-landlord" :class="{'active': contractState == 1 || contractState == 2 || contractState == 3}">
                            <img v-if="contractState == 1 || contractState == 2 || contractState == 3" src="@/assets/img/icon/radio_blue.svg" alt="">
                            <img v-else src="@/assets/img/icon/radio_gray.svg" alt="">
                            新增合約
                        </span>
                        <span class="progress-hr" :class="{'active': contractState == 2 || contractState == 3}"></span>
                        <span class="progress-tanant" :class="{'active': contractState == 2 || contractState == 3}">
                            <img v-if="contractState == 2 || contractState == 3" src="@/assets/img/icon/radio_blue.svg" alt="">
                            <img v-else src="@/assets/img/icon/radio_gray.svg" alt="">
                            上傳合約
                        </span>
                        <span class="progress-hr" :class="{'active': contractState == 3}"></span>
                        <span class="progress-desposit" :class="{'active': contractState == 3}">
                            <img v-if="contractState == 3" src="@/assets/img/icon/radio_blue.svg" alt="">
                            <img v-else src="@/assets/img/icon/radio_gray.svg" alt="">
                            租客確認
                        </span>
                    </span>
                    
                </span>
            </div>
            <div class="btn-group">
                <button v-if="contractState == 3" class="level3-btn view-new-contract" @click="toLeaseMgt(), $analytics.logEvent('查看新增合約', { screen_name: '查看新增合約'})">查看紙本合約</button>
                <button v-if="contractState == 2" class="border-button save" @click="saveContract(1), $analytics.logEvent('儲存合約資料', { screen_name: '儲存合約資料'})">儲存</button>
                <button v-if="contractState == 1" class="default-button next" @click="nextStep(), $analytics.logEvent('下一步：上傳合約', { screen_name: '下一步：上傳合約'})">下一步：上傳合約</button>
                <button v-else-if="contractState == 2" class="default-button next" @click="saveContract(0), $analytics.logEvent('通知租客', { screen_name: '通知租客'})" >通知租客確認</button>
                <!-- <button class="default-button next" @click="saveContract(0)" >下一步：上傳合約</button> -->
            </div>
        </div>
        <!-- <contract-status :disabledState="allDone"></contract-status> -->
        <div v-if="contractState == 1" class="tanant-info">
            <div class="block">
                <div class="block-title">租客資料</div>
                <div class="block-wrap">
                    <div class="phone">
                        <label for="">租客手機</label>
                        <div class="input-error-group">
                            <input :class="{error: error.phoneErr}" type="text" v-model="contractData.tenantPhone" placeholder="請輸入手機號碼">
                            <span v-show="error.phoneErr" class="error">{{error.phoneErr}}</span>
                        </div>
                    </div>
                    <div class="tanant-name">
                        <label for="">租客姓名</label>
                        <div class="input-error-group">
                            <input :class="{error: error.nameErr}" type="text" v-model="contractData.tenantName" placeholder="請輸入真實姓名">
                            <span v-show="error.nameErr" class="error">{{error.nameErr}}</span>
                        </div>
                    </div>
                    <div class="identification">
                        <label for="">身分證字號/居留證號</label>
                        <div class="input-error-group">
                            <input :class="{error: error.idErr}" type="text" v-model="contractData.tenantIdNumber" placeholder="請輸入身分證字號">
                            <span v-show="error.idErr" class="error">{{error.idErr}}</span>
                        </div>
                    </div>
                    <div class="upload-id">
                        <label for="">上傳身分證圖片(正反)</label>
                        <div class="upload-id-wrap">
                            <div v-if="identification.font.length > 0"  class="list-upload font-side">
                                <img  class="cancel" @click.prevent="identification.font = []" src="@/assets/img/icon/cancel_black.svg" alt="">
                                <div  class="preview">
                                    <img :src="identification.font[0].blob" />
                                </div>
                            </div>
                            <div v-else class="list-upload font-side">
                                <file-upload
                                v-if="identification.font.length == 0"
                                class="upload-btn"
                                post-action="/upload/post"
                                input-id="font"
                                :size="1024 * 5"
                                :maximum="1"
                                :multiple="true"
                                v-model="identification.font"
                                @input-filter="inputFilter"
                                ref="font">
                                <img v-if="identification.font.length == 0" class="upload-icon" src="@/assets/img/icon/upload_small.svg" alt="">
                                正面
                                </file-upload>
                            </div>
                            <div v-if="identification.back.length > 0" class="list-upload back-side">
                                <img class="cancel" @click.prevent="identification.back = []" src="@/assets/img/icon/cancel_black.svg" alt="">
                                <div class="preview">
                                    <img  :src="identification.back[0].blob" />
                                </div>
                                <img v-if="identification.back.length == 0" class="upload-icon" src="@/assets/img/icon/upload_small.svg" alt="">
                            </div>
                            <div v-else class="list-upload back-side">
                                <file-upload
                                v-if="identification.back.length == 0"
                                class="upload-btn"
                                post-action="/upload/post"
                                input-id="back"
                                :size="1024 * 5"
                                :maximum="1"
                                :multiple="true"
                                v-model="identification.back"
                                @input-filter="inputFilter"
                                ref="back">
                                    <img v-if="identification.back.length == 0" class="upload-icon" src="@/assets/img/icon/upload_small.svg" alt="">
                                    反面
                                </file-upload>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="block">
                <div class="block-title">選擇房源</div>
                <div class="block-wrap">
                    <div class="house-select">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span>
                                選擇房源
                            </div>
                            <span v-show="error.houseCid" class="error-with-title">{{error.houseCid}}</span>
                        </label>
                        <div class="input-arear">
                            <div v-if="selectedHouseInfo.houseName" class="house-info-wrap">
                                <default-radio :isPropChecked="true"></default-radio>
                                <div class="house-info">
                                    <div class="name">{{selectedHouseInfo.houseName}}</div>
                                    <div class="address">{{selectedHouseInfo.address}}</div>
                                    <div class="rent">租金：${{selectedHouseInfo.rent}}</div>
                                </div>
                                <button  class="border-button" @click="choseHouse()">選擇其他房源</button>
                            </div>
                            <button v-else class="border-button chose-house" @click="choseHouse()">選擇房源</button>
                            <button v-if="selectedHouseInfo.houseName" class="border-button-gray edit-house" @click="editHouse()">編輯房源</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="block">
                <div class="block-title">合約資料</div>
                <div class="block-wrap">
                    <div class="three-part move-in-date">
                        <label for="">租約起訖日</label>
                        <div class="input-error-group">
                            <date-picker v-model="datePeriod.contractPeriod" :class="{'active': contractData.contractBeginTime != null, 'errorr': error.dateErr}" :disabled-date="notBeforeThisday" placeholder="2020.05.06-2021.05.06"  format="YYYY-MM-DD" valueType="format" rangeSeparator="-" range></date-picker>
                            <span v-show="error.dateErr" class="error">{{error.dateErr}}</span>
                        </div>
                    </div>
                    <div class="three-part shortest-period">
                        <label for="">入住人數</label>
                        <div class="input-error-group">
                            <rent-select :class="{error: error.tenantNumberErr}" class="select-scroll" refName="shortestPeriod"  :selectMsg="contractData.tenantNumber?contractData.tenantNumber+'個人':'請選擇入住人數'" :isEdit="contractData.tenantNumber?true:false" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                                <ul>
                                    <li v-for="n in 100" :key="n" :data-id="n">
                                        {{n}} 個人
                                    </li>
                                </ul>
                            </rent-select>
                            <span v-show="error.tenantNumberErr" class="error">{{error.tenantNumberErr}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="contractState == 2" class="contract-file">
            <div class="block">
                <div class="block-title">上傳合約</div>
                <div class="block-wrap">
                    <div class="image-cover">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill">*</span>
                                紙本合約 PDF
                            </div>
                            <span v-show="error.tenantPhone" class="error-with-title">{{error.tenantPhone}}</span>
                        </label>
                        <div class="input-arear">
                            <div v-if="paperContract.length == 0" class="cover-block" :class="{'img-error': error.paperContract}">
                                <file-upload
                                class="upload-btn"
                                post-action="/upload/post"
                                :size="1024 * 5"
                                :maximum="1"
                                :multiple="true"
                                v-model="paperContract"
                                @input-filter="inputPaperContractFilter"
                                ref="uploadCover">
                                    <img class="upload-icon" src="@/assets/img/icon/upload_biz.svg" alt="">
                                    上傳PDF
                                </file-upload>
                            </div>
                            <div v-else class="cover-preview">
                                <div class="preview">
                                    <span v-if="paperContract[0].type == 'application/pdf'">
                                        {{paperContract[0].name}}
                                    </span>
                                    <img v-else :src="paperContract[0].blob" />
                                </div>
                                <file-upload
                                    class="replace"
                                    post-action="/upload/post"
                                    :size="1024 * 5"
                                    :maximum="1"
                                    :multiple="true"
                                    :drop="true"
                                    :drop-directory="true"
                                    v-model="paperContract"
                                    @input-filter="inputPaperContractFilter"
                                    ref="uploadCover">
                                        取代文件
                                </file-upload>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <label for="">紙本合約PDF</label>
            <div class="contract-file-wrap">
                <span class="pdf-name" v-if="paperContractType == 'pdf'">{{paperContract[paperContract.length-1].name}}</span>
                <file-upload
                    class="default-button upload-contract"
                    post-action="/upload/post"
                    :size="1024 * 5"
                    :maximum="uploadLimit"
                    :multiple="true"
                    :drop="true"
                    :drop-directory="true"
                    v-model="paperContract"
                    @input-filter="inputPaperContractFilter"
                    accept="pdf"
                    extensions="pdf"
                    ref="contractFile">
                    上傳
                </file-upload>
            </div>
            <div class="contract-list" v-if="paperContractType == 'image'">
                <ul>
                    <li v-for="(item, index) in paperContract" :key="index">
                        <img class="preview" :src="item.blob" alt="">
                        <img class="cancel" @click.prevent="$refs.contractFile.remove(item)" src="../../../../assets/img/icon/cancel_black.svg" alt="">
                    </li>
                </ul>
            </div> -->
        </div>
        <div v-if="contractState == 3" class="notify">
            <div class="title">
                <img src="../../../../assets/img/icon/success_black_large.svg" alt="">
                已通知租客確認
            </div>
            <div class="description">
                我們已發簡訊通知租客，您可以下載 App 追蹤進度，我們也會發送推播，通知您租客的簽約進度。
            </div>
            <div class="qr">
                <vue-qrious :value="hostUrl"  :size="size" level="L"/>
                <!-- <img src="../../../../assets/img/qrcode.png" alt=""> -->
                掃碼下載 App
            </div>
        </div>
    </div>
</template>
<script>
import ContractStatus from '@/components/landlord/houseStatus/newContract/ContractStatus.vue';
import RentSelect from '@/components/widge/RentSelect.vue';
import DatePicker from 'vue2-datepicker';
import FileUpload from 'vue-upload-component';
import VueQrious from 'vue-qrious'
import AlartMsg from '@/components/widge/AlartMsg.vue';
import DefaultRadio from '@/components/widge/DefaultRadio.vue';
import Modal from '@/components/widge/Modal.vue';
import TableSearch from '@/components/widge/TableSearch.vue';
import { 
    baseWebUrl
    } from "@/apis/api.js"; 
import { mapGetters } from 'vuex'

const today = new Date();
today.setHours(0, 0, 0, 0);
// console.log(today)
export default {
    data () {
        return {
            modalHeight: (window.innerHeight-400) + 'px',
            componentKey: 0,
            contractData: {
                "tenantName" : null,
                "tenantPhone" : null,
                "tenantIdNumber" : null,
                "contractBeginTime" : null,
                "contractEndTime" : null,
                "tenantNumber" : null
            },
            datePeriod: [],
            identification: {
                font: [],
                back: []
            },
            paperContract: [],
            paperContractType: null,
            uploadLimit: 100,
            isDefault: false,
            error: {
                phoneErr: null,
                nameErr: null,
                idErr: null,
                dateErr: null,
                tenantNumberErr: null,
            },
            size: 75,
            hostUrl: baseWebUrl + '?device=1',
            isDefault: false,
            selectedHouseInfo: {},
            modalStatus: {
                houseList: false
            },
            alart: {
                success: false,
                fail: false
            },
            msg: {
                success: null,
                error: null,
            },
            filter: {
                word: null,
            },
        }
    },
    created() {
        this.$store.dispatch('getNewContractAvailableHouse')
        .then(()=>{
            if(this.pcontractSelectedHouse.seleted != null){
                this.setHouseInfo()
            }
        })
    },
    mounted() {
        this.$analytics.logEvent("新增紙本合約");
    },
    destroyed() {
        if( this.contractState != 1 ){
            console.log('destory')
            this.$store.dispatch('setNewContractDefault')
        }
    },
    watch: {
        contractData: {
            handler: function (newValue, oldValue) {
                console.log(newValue)
                let phoneReg = /^09[0-9]{8}$/
                if(newValue.tenantPhone){
                    if( phoneReg.test(newValue.tenantPhone) ){
                        this.error.phoneErr = ''
                    }else{
                        this.error.phoneErr = '格式不符'
                    }
                }
                if(newValue.tenantName){
                    this.error.nameErr = ''
                }
                
                if(newValue.tenantIdNumber){
                    console.log(newValue.tenantIdNumber.length)
                    if(newValue.tenantIdNumber.length === 10){
                        this.error.idErr = null
                    }else{
                        this.error.idErr = '身分證格式錯誤'
                    }
                }
                if(newValue.contractEndTime && new Date(newValue.contractEndTime) < today){
                    this.error.dateErr = '租約訖日不可早於今日'
                }else if(newValue.contractEndTime){
                    this.error.dateErr = null
                }
               if(newValue.tenantNumber){
                    this.error.tenantNumberErr = ''
                }
              
                this.$store.dispatch('setNewContract', newValue)
            },
            deep:true
        },
        identification: {
            handler: function (newValue, oldValue) {
                this.$store.dispatch('setNewContractIdImg', newValue)
            },
            deep:true
        },
        paperContract: {
            handler: function (newValue, oldValue) {
                if( this.paperContractType == 'image' ){
                    this.paperContract.map( (contractItem, index) => {
                        if(/\.(pdf)$/i.test(contractItem.name)){
                            this.paperContract.splice(index,1);
                        }
                    });
                }else{
                    this.paperContract.map( (contractItem, index) => {
                        if(/\.(jpeg|jpe|jpg|png)$/i.test(contractItem.name)){
                            this.paperContract.splice(index,1);
                        }
                    });
                }
                this.$store.dispatch('setNewContractPaper', newValue)
            },
            deep:true
        },
        'datePeriod.contractPeriod': function (newValue, oldValue){
            this.contractData.contractBeginTime = newValue[0]
            this.contractData.contractEndTime = newValue[1]
        },
        paperContractType: function (val) {
            this.$store.dispatch('setNewContractPaperType', val)
        },
        uploadStatus: {
            handler: function (val) {
                if(val.status == true){
                    this.alart.fail = true
                    this.msg.error = val.msg
                }else{
                    this.alart.fail = false
                    this.msg.error = ''
                }
            },
            deep: true,
            immediate: true

        },
        notifyStatus: {
            handler: function (val) {
                console.log(val)
                if(val.status == true){
                    this.alart.success = true
                    this.msg.success = val.msg
                }else{
                    this.alart.success = false
                    this.msg.success = ''
                }
            },
            deep: true,
            immediate: true
        },
        pcontractData: {
            handler:  function (val) {
                console.log(val)
                this.contractData = val
            },
            immediate: true
        },
        pcontractIdCard: {
            handler:  function (val) {
                this.identification = val
            },
            immediate: true
        },
        pcontractDatePeriod: {
            handler:  function (val) {
                this.datePeriod = val
            },
            immediate: true
        },
        pcontractSelectedHouse: {
            handler:  function (val) {
                this.selectedHouseInfo = val
            },
            immediate: true
        },
        
    },
    methods: {
        getSelectId: function (value) {
            // console.log(value)
            let targetId = parseInt(event.target.dataset.id)
            if( value.ref == 'shortestPeriod' ){
                this.contractData.tenantNumber = targetId
            }
        },      
        choseHouse: function () {
            // document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
            this.modalStatus.houseList = true
        }, 
        closeModal: function () {
            // document.getElementsByClassName('parent-frame')[0].style.zIndex = '8'
            this.modalStatus.houseList = false
            this.setFilterDefault()
        }, 
        setFilterDefault: function () {
            this.filter = {
                word: null,
            }
        },   
        inputFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpe|jpg|png)$/i.test(newFile.name)) {
                    this.alart.fail = true
                    this.msg.error = '請上傳JPG或PNG檔案'
                    return prevent()
                }
                if(newFile.size > (1024*1024*5)){
                    this.alart.fail = true
                    this.msg.error = '檔案最大限制5MB'
                    return prevent()
                }
            }
            // console.log(newFile)
            
            // Create a blob field
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
        },
        checkTwID: function (id){
            //建立字母分數陣列(A~Z)
            var city = new Array(
                1,10,19,28,37,46,55,64,39,73,82, 2,11,
                20,48,29,38,47,56,65,74,83,21, 3,12,30
            )
            id = id.toUpperCase();
            // 使用「正規表達式」檢驗格式
            if (id.search(/^[A-Z](1|2)\d{8}$/i) == -1) {
                return false;
            } else {
                //將字串分割為陣列(IE必需這麼做才不會出錯)
                id = id.split('');
                //計算總分
                var total = city[id[0].charCodeAt(0)-65];
                for(var i=1; i<=8; i++){
                    total += eval(id[i]) * (9 - i);
                }
                //補上檢查碼(最後一碼)
                total += eval(id[9]);
                //檢查比對碼(餘數應為0);
                return ((total%10 == 0 ));
            }
        },
        inputBackFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpe|jpg|png)$/i.test(newFile.name)) {
                return prevent()
                }
            }
            // console.log(newFile)
            
            // Create a blob field
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
        },
        inputPaperContractFilter: function (newFile, oldFile, prevent) {

            if (newFile && !oldFile) {
                // Filter non-image file
                // if (!/\.(jpeg|jpe|jpg|png|pdf)$/i.test(newFile.name)) {
                //     return prevent()
                // }else 
                if (/\.(pdf)$/i.test(newFile.name)) {
                    this.paperContractType = 'pdf'
                }else{
                    this.alart.fail = true
                    this.msg.error = '請上傳PDF檔案'
                    return prevent()
                }
                if(newFile.size > (1024*1024*10)){
                    this.alart.fail = true
                    this.msg.error = '檔案最大限制10MB'
                    return prevent()
                }
                // else if(/\.(jpeg|jpe|jpg|png)$/i.test(newFile.name)){
                //     this.paperContractType = 'image'
                // }
            }
            
            // Create a blob field
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
        },
        saveContract: function (action) {
            // console.log('saveContract')
            if(this.checkContract()){
                this.$store.dispatch('saveNewContract', action)
            }
        },
        nextStep: function () {
            // console.log(this.checkInput())
            if( this.contractState == 1 && this.checkInput()){
                this.$store.commit('newContract/set_contract_status', 2)
            }
        },
        // savePaperContract: function (action) {
        //     // console.log('savePaperContract')
        //     if( this.contractState == 2){
        //         this.$store.dispatch('saveNewContratFile', action)
        //     }
            
        // },
        editHouse(){
            if(this.selectedHouseInfo.houseStatus !== 2){
                this.$router.push({name: 'editHouse', query: {'cid': this.selectedHouseInfo.houseCid,'type': 'contract'}})
            }else{
                this.$store.dispatch('setAlarmStatus', {status: true,title: '預定中不可編輯',type: 'error'})
            }
        },
        toLeaseMgt: function () {
            window.location.href = '/landlord/leasemanagement/home?#紙本確認中'
            dispatch('setAlarmStatus', {status: true,title: '新增紙本合約成功',type: 'success',closeBtn: true})
            
        },
        checkInput: function () {
            if(!this.contractData.tenantPhone){
                this.error.phoneErr = '請填寫租客手機'
            }
            if(!this.contractData.tenantName){
                this.error.nameErr = '請填寫租客姓名'
            }else{
                this.error.nameErr = ''
            }
            // if(!this.contractData.tenantGender){
            //     this.error.sexErr = '請選擇租客性別'
            // }else{
            //     this.error.sexErr = ''
            // }
            if(!this.contractData.tenantIdNumber){
                this.error.idErr = '請填寫身份字號'
            }
            if(!this.contractData.contractBeginTime){
                this.error.dateErr = '請填寫租約起訖日'
            }
            if(!this.contractData.tenantNumber){
                this.error.tenantNumberErr = '請填寫入住人數'
            }
   
            if(
                this.contractData.tenantName &&
                this.contractData.tenantPhone &&
                this.contractData.tenantIdNumber &&
                this.contractData.contractBeginTime &&
                this.contractData.contractEndTime &&
                this.contractData.tenantNumber &&
                !this.error.phoneEr  &&
                !this.error.idEr  &&
                !this.error.dateEr
            ){
                return true
            }else{
                return false
            }
        },
        checkContract: function () {
            if(this.paperContract.length > 0){
                return true
            }else{
                this.alart.fail = true
                this.msg.error = '未上傳紙本合約'
                return false
            }
        },
        changeUploadStatus: function (){
            this.$store.commit('newContract/set_upload_status', {
                status: false,
                msg: '',
            })
        },
        changeNotifyStatus: function () {
            this.$store.commit('newContract/set_notify_status', {
                status: false,
                msg: '',
            })
        },
        setHouseInfo: function () {
            let house = null
            this.houseList.forEach(element => {
                console.log(element)
                if(element.houseCid === this.selectedHouseInfo.houseCid){
                    house =  element
                }
            });
            this.contractData.houseCid = house.houseCid
            this.selectedHouseInfo = Object.assign({}, house)
            this.$store.dispatch('setNewContractSelectedHouse', this.selectedHouseInfo)
            this.$store.dispatch('getGetContractPeriod', this.selectedHouseInfo.houseCid)
        },
        notBeforeThisday(date) {
            let contractPeriod = this.pcontractPeriod
            if(contractPeriod.length){
                for (let i = 0; i < contractPeriod.length; i++) {
                    const element = contractPeriod[i];
                    
                    if(element.contractBeginTime-86400000 < date &&  element.contractEndTime+86400000 > date){
                        return true
                    }
                }
            }
        },
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6];
        },
        
    },
    computed:{
        filterByWord: function () {
            return this.houseList.filter((item) => {
                if( this.filter.word ){
                    if( item.address.includes(this.filter.word)){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        ...mapGetters({
            houseList: 'GET_NEW_CONTRACT_AVAILABLE_HOUSE',
            contractState: 'GET_CONTRACT_STATUS',
            uploadStatus: 'GET_UPLOAD_STATUS',
            notifyStatus: 'GET_NOTIFY_STATUS',
            pcontractData: 'GET_NEW_CONTRACT_DATA',
            pcontractIdCard: 'GET_NEW_CONTRACT_IDENTIFICATION',
            pcontractDatePeriod: 'GET_NEW_CONTRACT_DATE_PERIOD',
            pcontractSelectedHouse: 'GET_NEW_CONTRACT_SELECTED_HOUSE',
            pcontractPeriod: 'GET_NEW_CONTRACT_PERIOD',
        })
    },
    components: {
        ContractStatus,
        RentSelect,
        DatePicker,
        FileUpload,
        'vue-qrious': VueQrious,
        AlartMsg,
        DefaultRadio,
        TableSearch,
        Modal
    }
}
</script>
<style lang="scss" scoped>
    .new-contract{
        position: relative;
        margin-bottom: 300px;
        #modal.house-list{
            .modal-content{
                width: 900px;
                padding: 0 !important;
                .detail{
                    align-items: flex-start !important;
                    h1{
                        display: flex;
                        font-size: 24px;
                        margin: auto;
                        margin-top: 32px;
                        margin-bottom: 32px;
                    }
                    .group{
                        display: flex;
                        margin-bottom: 12px;
                        .table-search{
                            width: 573px;
                            margin-right: 10px;
                        }
                        .biz-rent-select{
                            width: 216px;
                        }
                    }
                    .content{
                        width: 833px;
                        margin-bottom: 8px;
                        padding: 0px 32px;
                        .table-title{
                            padding: 20px 0;
                            border-top: 1px solid #F1F5F4;
                            border-bottom: 1px solid #F1F5F4;
                            display: flex;
                            align-items: center;
                            color: #a8a5a4;
                            .name{
                                width: 235px;
                                margin-left: 57px;
                                margin-right: 50px;
                            }
                            .address{
                                width: 265px;
                                margin-right: 50px;
                            }
                            .agent{
                                width: 50px;
                                margin-right: 50px;
                            }
                        }
                        .table-body{
                            ul{
                                height: 360px;
                                overflow-x: hidden;
                                &::-webkit-scrollbar {
                                    display: none;
                                }
                                li{
                                    display: flex;
                                    align-items: center;
                                    padding: 20px 0;
                                    border-bottom: 1px solid #F1F5F4;
                                    .name{
                                        width: 235px;
                                        margin-left: 24px;
                                        margin-right: 50px;
                                    }
                                    .address{
                                        width: 265px;
                                        margin-right: 50px;
                                    }
                                    .agent{
                                        width: 50px;
                                        margin-right: 50px;
                                    }
                                }
                            }
                            ul::-webkit-scrollbar {
                                display: none;
                            }
                        }
                    }
                    .btn-group{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        height: 84px;
                        box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                        border-radius:  0 0 20px 20px;
                        margin: 0 auto;
                        button{
                            width: 184px;
                            height: 44px;
                        }
                    }
                }
            }
        }
        span.error{
            bottom: unset;
            left: unset;
            right: 0px;
            top: -21px;
        }
        .contract-state{
            position: relative;
            display: flex;
            align-items: center;
            width: 1106px;
            height: 44px;
            padding: 14px 24px;
            margin-bottom: 30px;
            border-radius: 10px;
            box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
            background-color: #ffffff;
            .progress-bar{
                display: flex;
                align-items: center;
                .progress-landlord,
                .progress-tanant,
                .progress-desposit{
                    display: flex;
                    align-items: center;
                    font-size: 12px;
                    color: #a8a5a4;
                    img{
                        margin-right: 8px;
                    }
                }
                .progress-landlord.active,
                .progress-tanant.active,
                .progress-desposit.active{
                    color: #71aae5;
                }
                .progress-landlord,
                .progress-tanant{
                    width: 72px;
                }
                .progress-desposit{
                    width: 85px;
                }
                .progress-hr{
                    width: 208px;
                    height: 1px;
                    background: #cacfcd;
                    margin: 0 16px;
                }
                // .progress-hr.active{
                //     background: #f5a623;
                // }
            }
            .btn-group{
                position: absolute;
                display: flex;
                right: 24px;
                .save{
                    width: 132px;
                    margin-right: 12px;
                }
                .next{
                    width: 200px;
                }
                .view-new-contract{
                    width: 200px;
                    height: 44px;
                    cursor: pointer;
                }
            }
        }
        .block{
            margin-bottom: 30px;
            width: 1154px;
            label{
                position: relative;
                margin-bottom: 12px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-weight: 500;
            }
            .block-title{
                display: flex;
                align-items: center;
                font-size: 20px;
                margin-bottom: 30px;
                color: #ff9275
            }
            .block-wrap{
                position: relative;
                display: flex;
                flex-wrap: wrap;
                align-items: flex-start;
                justify-content: space-between;
                border: solid 1px #f0f0f0;
                background-color: #ffffff;
                padding: 24px;
                border-radius: 8px;
                input{
                    height: 44px;
                }
                >div{
                    width: 308px;
                    margin-right: 90px;
                    margin-bottom: 30px;
                    &.house-select{
                        width: 100%;
                    }
                }
                >div:nth-child(3n){
                    margin-right: 0px;
                }
                .upload-id{
                    .upload-id-wrap{
                        display: flex;
                        .list-upload{
                            position: relative;
                            width: 148px;
                            height: 111px;
                            margin-right: 12px;
                            border-radius: 4px;
                            border: dashed 1px #cacfcd;
                            background-color: #ffffff;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            .upload-icon{
                                width: 24px;
                                height: 24px;
                                margin-bottom: 4px;
                            }
                            .cancel{
                                position: absolute;
                                cursor: pointer;
                                top: -14px;
                                right: -14px;
                            }
                            .preview{
                                width: 148px;
                                height: 111px;
                                display: flex;
                                align-items: center;
                                border-radius: 4px;
                                overflow: hidden;
                                >img{
                                    width: 100%;
                                }
                            }
                            .file-uploads{
                                width: 100%;
                                height: 100%;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                justify-content: center;
                            }
                        }
                    }
                    
                }
                .three-part{
                    width: 308px;
                    margin-right: 115px;
                    margin-bottom: 30px;
                }
                .move-in-date{
                    position: relative;
                    .mx-datepicker{
                        width: 308px;
                        input{
                            width: 100%;
                            height: 44px;
                            border-radius: 4px;
                            border: solid 1px #f3f3f3;
                            color: #a8a5a4;
                            padding: 13px 16px;
                            box-shadow: none;
                            margin-bottom: 0px;
                        }
                        .mx-icon-calendar,
                        .mx-icon-clear{
                            right: 14px;
                        }
                    }
                    .mx-datepicker:hover,
                    .mx-datepicker.active{
                        input{
                            border: 1px solid #676362 !important;
                            color: #676362 !important;
                        }
                        i{
                            color: #676362;
                        }
                    }
                    .mx-datepicker.errorr{
                        input{
                            border: 1px solid #fc7171 !important;
                        }
                    }
                }
                span.error{
                    bottom: unset;
                    left: unset;
                }
                .house-select{
                    .chose-house{
                        width: 324px;
                    }
                    .edit-house{
                        width: 120px;
                    }
                    .house-info-wrap{
                        position: relative;
                        display: flex;
                        align-items: center;
                        width: 546px;
                        height: 108px;
                        border-radius: 4px;
                        border: solid 1px #ff9275;
                        background: #fff;
                        padding: 16px 24px 16px 24px;
                        box-sizing: border-box;
                        margin-right: 12px;
                        .dafault-checkbox{
                            margin-bottom: 0px;
                        }
                        .house-info{
                            margin-left: 22px;
                            >div{
                                margin-bottom: 6px;
                            }
                        }
                        >button{
                            position: absolute;
                            right: 40px;
                            height: 44px;
                            border: none;
                        }
                    }
                    .input-arear{
                        display: flex;
                        align-items: center;
                    }
                }
                .image-cover{
                .cover-block{
                    position: relative;
                    width: 124px;
                    height: 93px;
                    border-radius: 4px;
                    border: dashed 1px #cacfcd;
                    background-color: #ffffff;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    img{
                        width: 24px;
                        margin-bottom: 4px;
                    }
                    .upload-btn{
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                    }
                    .img-error{
                        position: absolute;
                        width: 200px;
                        left: 136px;
                        font-weight: 500;
                        font-size: 12px;
                        color:  #F05A3E;
                        top: unset;
                    }
                }
                .cover-block.img-error{
                    border: dashed 1px #F05A3E;
                }
                .cover-preview{
                    display: flex;
                    align-items: center;
                    .preview{
                        display: flex;
                        margin-right: 8px;
                        align-items: center;
                        color: #ff9275;
                        text-decoration: underline;
                    }
                    .replace{
                        width: 104px;
                        height: 44px;
                        border-radius: 4px;
                        border: solid 1px #e0dfde;
                        background: #fff;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                }
            }
        }
    }
        label{
            display: block;
            font-weight: 500;
            margin-bottom: 12px;
        }
        .rent-select{
            background: #fff;
        }
        .rent-select.error{
            bottom: unset;
            left: unset;
        }
        .notify{
            position: relative;
            margin-top: 40px;
            .title{
                display: flex;
                align-items: center;
                font-size: 20px;
                font-weight: 500;
                margin-bottom: 14px;
                img{
                    margin-right: 12px;
                }
            }
            .description{
                width: 400px;
                font-weight: 300;
                line-height: 1.57;
                margin-bottom: 20px;
            }
            .qr{
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                img{
                    padding: 10px;
                    background: #fff;
                    margin-bottom: 12px;
                }
            }
        }
    }
    @media screen and (max-width: 1280px) {
        .new-contract{
            .contract-state{
                width: 1096px;
            }
            .tanant-info{
                .tanant-info-wrap{
                    >div{
                        margin-right: 109px;
                    }
                }
            }
            .contract-info{
                .contract-info-wrap{
                    .three-part{
                        margin-right: 109px;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/houseStatus/newContract/NewContract.vue